const initialState = {
  loading: null,
  data: null,
  session: null,
  message: null,
  error: [null, null],
  tef: {},
  status: null,
  present: null,
};

// export default mock.pdv.pinpad;
export default initialState;
